import { StorefrontError } from '../core/error'
import { execute } from '@shared/shop-api/customer/execute-graphql'
import { toCustomer } from '@shared/shop-api/customer/mapper'
import {
  customerQuery,
  setCustomerCartIdQuery,
} from '@shared/shop-api/customer/query'

export const getCustomer = async () => {
  try {
    const data = await execute(customerQuery)

    return data ? toCustomer(data.customer) : null
  } catch (error) {
    throw new StorefrontError('Customer fetch failed', error)
  }
}

export const setCustomerCartId = async (ownerId: string, cartId: string) => {
  const data = await execute(setCustomerCartIdQuery, {
    metafields: [
      {
        key: 'cart_id',
        namespace: 'custom',
        ownerId,
        type: 'single_line_text_field',
        value: cartId,
      },
    ],
  })

  return data?.metafieldsSet?.metafields
}
